<script lang="ts">
  /*
   * A simple pulsing placeholder for loading indication.
   */
</script>

<span
  class="group block flex h-full w-full animate-pulse flex-col overflow-hidden rounded-b bg-[#d3d4de] text-left"
  >&nbsp;
</span>
